var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.85C15 18.2977 14.5523 17.85 14 17.85H12.6667C12.1144 17.85 11.6667 18.2977 11.6667 18.85V20.15C11.6667 20.7023 12.1144 21.15 12.6667 21.15H14C14.5523 21.15 15 20.7023 15 20.15V18.85ZM21.6667 18.85C21.6667 18.2977 21.219 17.85 20.6667 17.85H19.3333C18.781 17.85 18.3333 18.2977 18.3333 18.85V20.15C18.3333 20.7023 18.781 21.15 19.3333 21.15H20.6667C21.219 21.15 21.6667 20.7023 21.6667 20.15V18.85ZM28.3333 18.85C28.3333 18.2977 27.8856 17.85 27.3333 17.85H26C25.4477 17.85 25 18.2977 25 18.85V20.15C25 20.7023 25.4477 21.15 26 21.15H27.3333C27.8856 21.15 28.3333 20.7023 28.3333 20.15V18.85ZM31.6667 6.3H30V4C30 3.44771 29.5523 3 29 3H27.6667C27.1144 3 26.6667 3.44772 26.6667 4V6.3H13.3333V4C13.3333 3.44771 12.8856 3 12.3333 3H11C10.4477 3 10 3.44772 10 4V6.3H8.33333C6.48333 6.3 5.01667 7.785 5.01667 9.6L5 32.7C5 34.515 6.48333 36 8.33333 36H31.6667C33.5 36 35 34.515 35 32.7V9.6C35 7.785 33.5 6.3 31.6667 6.3ZM31.6667 32.7H8.33333V14.55H31.6667V32.7Z",
    fill: "#B0B3F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 26.1C28.3333 27.0113 27.5871 27.75 26.6667 27.75C25.7462 27.75 25 27.0113 25 26.1C25 25.1887 25.7462 24.45 26.6667 24.45C27.5871 24.45 28.3333 25.1887 28.3333 26.1Z",
    fill: "#B0B3F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 26.1C21.6667 27.0113 20.9205 27.75 20 27.75C19.0795 27.75 18.3333 27.0113 18.3333 26.1C18.3333 25.1887 19.0795 24.45 20 24.45C20.9205 24.45 21.6667 25.1887 21.6667 26.1Z",
    fill: "#B0B3F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26.1C15 27.0113 14.2538 27.75 13.3333 27.75C12.4129 27.75 11.6667 27.0113 11.6667 26.1C11.6667 25.1887 12.4129 24.45 13.3333 24.45C14.2538 24.45 15 25.1887 15 26.1Z",
    fill: "#B0B3F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.294de9af.svg";
export { ForwardRef as ReactComponent };